import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const AsserCategories = () => {
  return <ErpTablePage moduleKey="asset_categories" />;
};

export default AsserCategories;